module.exports = __webpack_public_path__ + "img/sample_header_3.39d094a6.jpg";